module.exports = __webpack_public_path__ + "static/media/shoe-prints.6c6d2caf.svg";